

import React, { Component } from 'react';
import { Route, Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import ShareIcon from '@material-ui/icons/Share';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Grid from '@material-ui/core/Grid';

import * as moment from 'moment';

import i18n from '../i18n/i18n';
import PersonFocus from './PersonFocus';

import firebase from 'firebase/app';
import 'firebase/firestore';
import ButtonAppBar from './material-ui/ButtonAppBar';
import SimpleSnackbar from './material-ui/SimpleSnackbar';


const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
});


class PersonList extends Component {

    unsubscribe;

    constructor(props) {
        super(props);
        this.state = {
            personsFS: [],
            showAddForm: false,
            scoreName: '',
            menuOpen: null,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancelAddScore = this.cancelAddScore.bind(this);
        this.addScoreButton = this.addScoreButton.bind(this);
        this.handleMenuChange = this.handleMenuChange.bind(this);
        this.logOff = this.logOff.bind(this);
        this.logIn = this.logIn.bind(this);
    }

    handleOnSnapshot(querySnapshot) {
        const docs = querySnapshot.docs;
        if (docs.length === 0 ){
            this.setState({
                personsFS: docs,
                showAddForm: true,
                scoreName: 'first account'
            });
        } else {
        this.setState({ 
            personsFS: docs,
         });
        }
    }

    componentDidMount() {
        const uid = firebase.auth().currentUser.uid;
        var db = firebase.firestore();

        this.unsubscribe = db.collection("persons").where("permissionRead." + uid, "==", true)
            .onSnapshot(
                this.handleOnSnapshot.bind(this)
            );
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    addScoreButton(event) {
        event.preventDefault()
        this.setState({
            showAddForm: !this.state.showAddForm,
            menuOpen: null,
        });
    }

    logOff(event){
        event.preventDefault();
        firebase.auth().signOut();
        this.props.childProps.doToNamedUser(false);
        this.props.childProps.userHasAuthenticated(false);
    }

    logIn(event){
        event.preventDefault();
        this.props.childProps.doToNamedUser(true);
    }

    handleSubmit(event) {
        const uid = firebase.auth().currentUser.uid;
        let db = firebase.firestore();
        db.collection("persons").add({
            personName: this.state.scoreName,
            points: 0,
            lastPointsAdd: 0,
            note: '',
            permissionWrite: { [uid]: true },
            permissionRead: { [uid]: true }
        })
            .then(function (docRef) {
                console.log("Document written with ID: ", docRef.id);
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });
        this.setState({
            showAddForm: !this.state.showAddForm,
            scoreName: '',
        });
        event.preventDefault();
    }

    cancelAddScore(event) {
        this.setState({
            showAddForm: !this.state.showAddForm,
            scoreName: '',
        });
        event.preventDefault();
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        event.preventDefault();
    }

    getAddScoreForm() {
        return (
            <div>
                <Dialog
                    open={this.state.showAddForm}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">Add account name</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Enter the name of the account please.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            autoComplete='off'
                            margin="dense"
                            id="scoreName"
                            name="scoreName"
                            label="account name"
                            type="text"
                            value={this.state.scoreName}
                            onChange={this.handleChange}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.cancelAddScore} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.handleSubmit} color="primary">
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );

    }

    handleMenuChange(event){
        event.preventDefault()
        if (!this.state.menuOpen){
           this.setState({menuOpen: event.currentTarget}) 
        } else{
            this.setState({menuOpen: null})
        }
    }
    

    render() {
        const classes = this.props.classes;
        const listItems = this.state.personsFS.map((docSnapshot) => {
            const data = docSnapshot.data();
            let backgroundStyle = {};
            if(data.hasOpenRequest){
                backgroundStyle = {backgroundColor : '#ffe0b3'}
            }
            return(        
                    <ListItem key={docSnapshot.id} button component={Link} style={backgroundStyle}
                            to={'/personfocus/' + docSnapshot.id} divider>
                        <ListItemText primary={data.personName}/>
                        <ListItemText primary={ // somtimes its null, so must check.
                            data.lastUpdate?moment(data.lastUpdate.toDate()).fromNow():null
                        }/>
                        <ListItemIcon>
                        {(Object.keys(data.permissionRead).length > 1)?
                            <ShareIcon /> : <ShareIcon style={{opacity: 0}}/>}
                        </ListItemIcon>            
                        <ListItemText primary={data.points}/>
                    </ListItem>          
            )
        });
        const propPersonFS = this.state.personsFS;

        //show email or uid in menu base on login state (anonymous or named).
        const currentUser = firebase.auth().currentUser;
        const emailOrUid = currentUser.email? currentUser.email: currentUser.uid;
        //menu option to login or off based on current state.
        let logInOff = ['Log off', this.logOff];
        if (currentUser.isAnonymous){
            logInOff = ['Log On', this.logIn]
        }
        const propMenuItems =[
            [i18n.t('add_person'), this.addScoreButton],
            logInOff,
            [emailOrUid.substring(0,20),()=>{}],
            ['Recycle Bin',()=>{this.props.history.push("/recyclebin")}],
        ];
        const propMenuHandlers = {
            propMenuItems: propMenuItems,
            propHandleMenu: this.handleMenuChange,
            propMenuState: this.state.menuOpen
        }

        return (
            <div>                
                <ButtonAppBar propMenuHandlers = {propMenuHandlers} />
                {this.getAddScoreForm()}

                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center">
                    <div className={classes.root}>
                        <List component="nav">
                            {listItems}
                        </List>
                    </div>
                </Grid>
                <div>
                    {currentUser.isAnonymous && listItems.length !== 0 && <SimpleSnackbar login={this.logIn}/>}
                </div>
                <Route exact path="/personfocus/:id"
                    render={(props) =>
                        <PersonFocus propPersonFS={propPersonFS} {...props} />} />
            </div>
        );
    }
}

export default withStyles(styles)(PersonList);




// WEBPACK FOOTER //
// ./src/components/PersonList.js